<hd-dialog [closeRequested]="closeRequested" dialogTitle="feedbackDialog.title">
  <ng-container dialogActions>
    <button class="filled" (click)="submit()"><i class="icon-send"></i>{{ 'feedbackDialog.action.submit' | translate }}</button>
  </ng-container>
  <ng-container dialogContent>
    <div class="flex flex-col gap-6">
      <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-4">
        <hd-card-picker [control]="form.controls.rating" label="feedbackDialog.rating.label" [options]="ratingOptions" translatePrefix="feedbackDialog.rating.option"/>
        <hd-textarea [control]="form.controls.message" label="feedbackDialog.message.label" description="feedbackDialog.message.label.description"/>
      </form>
    </div>
  </ng-container>
</hd-dialog>
